 
 
 
 
 
 
define(['./geopolViewService'], function(GeopolViewService) {
    'use strict';
    return new GeopolViewService();
});



// WEBPACK FOOTER //
// ./config/geopolView/globalGeopolViewService.js